import { Row, Col, Label, Input } from "reactstrap";

const DeviceChangeContent = () => {
  return (
    <div>

      <Row className="mb-3">
        <Col md={6}>
          <Label className="text-muted">Old Device ID:</Label>
          <div className="fw-semibold">DEV00987</div>
        </Col>

        <Col md={6}>
          <Label className="text-muted">Requested ID</Label>
          <div className="fw-semibold">DEV88765</div>
        </Col>
      </Row>

      {/* Remarks */}
      <Row>
        <div className="mb-4">
          <Label className="mb-2">Surveyor Remarks:</Label>
          <Input
            type="textarea"
            value="Device malfunctioning frequently, requesting replacement."
            rows={3}
            disabled
            style={{
              backgroundColor: "#f8f9fa",
              border: "1px solid #ddd",
              borderRadius: "8px",
            }}
          />
        </div>
      </Row>
    </div>
  );
};

export default DeviceChangeContent;
